var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons set"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85547 9.42362C6.61397 9.42362 6.41797 9.22762 6.41797 8.98612V4.71204C6.41797 4.47054 6.61397 4.27454 6.85547 4.27454C7.09697 4.27454 7.29297 4.47054 7.29297 4.71204V8.98612C7.29297 9.22762 7.09697 9.42362 6.85547 9.42362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99438 7.28625H4.7168C4.47471 7.28625 4.2793 7.09025 4.2793 6.84875C4.2793 6.60725 4.47471 6.41125 4.7168 6.41125H8.99438C9.23588 6.41125 9.43188 6.60725 9.43188 6.84875C9.43188 7.09025 9.23588 7.28625 8.99438 7.28625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12132 1.45862C2.50432 1.45862 1.45898 2.5652 1.45898 4.27904V9.42987C1.45898 11.1437 2.50432 12.2503 4.12132 12.2503H9.58832C11.2059 12.2503 12.2507 11.1437 12.2507 9.42987V4.27904C12.2507 2.5652 11.2059 1.45862 9.58832 1.45862H4.12132ZM9.58832 13.1253H4.12132C2.00557 13.1253 0.583984 11.6401 0.583984 9.42987V4.27904C0.583984 2.06878 2.00557 0.583618 4.12132 0.583618H9.58832C11.7041 0.583618 13.1257 2.06878 13.1257 4.27904V9.42987C13.1257 11.6401 11.7041 13.1253 9.58832 13.1253Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadWhite);
export default __webpack_public_path__ + "static/media/icon-upload-white.192fe61a6c31b561607c624c32865f27.svg";
export { ForwardRef as ReactComponent };